<template>
  <div>
    <div
      class="d-flex flex-column bet-slip-confirmation-row"
      :class="{ 'custom-confirmation-row': customConfirmationRow }"
      v-for="(selection, selectionIndex) in [...(bet.Details ? bet.Details : bet.Selections)]"
      :key="selection.OutComeId"
    >
      <div v-if="keepOld" class="d-flex justify-content-between align-items-end mb-2 custom-selection-lines">
        <div class="selection-desc">
          <span>
            {{ removeRotationNumberFromSelection(selection, selection.OutComeDescription) }}
          </span>
          <span v-if="selection.MarketType === 'to'">
            {{ parseFloat(selection.Point) < 0 ? $t('OVER') : $t('UNDER') }}
          </span>
          <div style="color: #131e32 !important" v-if="selection.pitcher_selection">
            {{
              selection.pitcher_selection_description
                .replace(/-R/g, $t('Pitcher.RightHand'))
                .replace(/-L/g, $t('Pitcher.LeftHand'))
                .replace(/- R/g, $t('Pitcher.RightHand'))
                .replace(/- L/g, $t('Pitcher.LeftHand'))
                .replace(/Action/g, $t('Pitcher.Action'))
            }}
          </div>
        </div>
        <bet-slip-odds :spread="selection" :odds="selection" :line="selection" v-if="!betHasError" />
      </div>
      <div v-else class="bet-slip-line-subheader m-0 bg-white">
        <div class="title d-flex flex-grow-1 flex-column" v-if="!betHasError">
          <div class="bold-title d-flex w-100 align-items-baseline">
            <div class="flex-grow-1 text-uppercase">
              {{ checkSpreadPk(selection, selection.OutComeDescription) }}
            </div>
            <div class="d-flex ml-auto">
              <bet-slip-odds
                class="bet-slip-odd"
                :spread="selection.spread_after_points"
                :odds="selection.odds_after_points"
                :line="selection"
                :wait_for_accept="selection.wait_for_accept_get_confirmation"
                :changed_type="
                  selection.changed_type === 'minus' ? 'plus' : selection.changed_type === 'plus' ? 'minus' : null
                "
              ></bet-slip-odds>
            </div>
          </div>
          <div class="sub-text-color d-flex">
            <div class="flex-grow-1">
              {{ selection.MarketDescription }}
            </div>
          </div>
          <div style="color: #131e32 !important" v-if="selection.PitcherOptions && selection.PitcherOptions.length">
            {{ selection.PitcherOptions.find(pc => pc.Id == selection.Pitcher).Description }}
          </div>
          <div class="sub-text-color" style="margin-right: 35px">
            <span v-if="isLive(selection.OutcomeId)" class="d-inline-block mr-1">
              <live-icon></live-icon>
            </span>
            {{ selection.GameDescription }}
          </div>
          <div style="display: none">
            wait_for_accept_get_confirmation:{{ selection.wait_for_accept_get_confirmation }}
          </div>
        </div>
      </div>

      <div v-if="(bet.WagerType === 'if_win' || bet.WagerType === 'if_win_or_tie') && !betHasError">
        <div class="mb-2 d-flex justify-content-between align-items-center placed-risk-win-area">
          <span class="title align-items-start" style="font-size: 13px">
            {{ $t('Risk') }} : {{ currencySymbol }}{{ bet.input_risk_amount || '0.00' }}
          </span>
          <span class="title align-items-end" style="font-size: 13px">
            {{ $t('Win') }} : {{ currencySymbol }}{{ getWinAmountForIfBet(bet, selection.Odd).toFixed(2) }}
          </span>
        </div>
      </div>
    </div>

    <bet-accept-area :bet="bet" :socket-update="true" :key="componentKey" v-if="!betHasError" />
    <bet-alert-message v-if="betHasError" error withoutIcon :description="parseBetErrorMessage(bet, currencySymbol)" />
  </div>
</template>

<script>
import { removeRotationNumberFromSelection, parseBetErrorMessage, checkSpreadPk } from './bet-slip-utils';
import BetSlipOdds from './BetSlipOdds';
import { mapGetters, mapState } from 'vuex';
import snq from 'snq';
import { trim } from 'lodash';
import { isLive } from '@/views/sports/components/bet-slip/check-bets';
import LiveIcon from '@/views/sports/components/bet-slip/LiveIcon';
import BetAcceptArea from './BetAcceptArea';
import { americanToDecimal } from './bet-slip-utils';
import { getBetDescription } from './getBetDescription';

export default {
  props: ['bet', 'keepOld', 'customConfirmationRow'],
  components: {
    BetAcceptArea,
    BetSlipOdds,
    LiveIcon,
  },
  data() {
    return {
      componentKey: 0,
    };
  },
  watch: {
    bet() {
      this.componentKey++;
    },
  },
  computed: {
    ...mapGetters('player', ['currencySymbol']),
    ...mapState({
      activeFreeBet: state => state.betSlip.activeFreeBet,
    }),
    betHasError() {
      const errorObj = this.bet;
      const errorCode = errorObj && errorObj.ErrorMessageKey;

      if (!errorCode) return null;
      return errorObj;
    },
  },
  methods: {
    isLive,
    removeRotationNumberFromSelection,
    parseBetErrorMessage,
    checkSpreadPk,
    tryGetGameDescription(selection) {
      return getBetDescription(selection);
    },
    getRiskAmount(bet) {
      if (bet && bet.input_risk_amount) {
        return bet.input_risk_amount;
      }
      return '0.00';
    },
    getWinAmount(bet) {
      if (bet && bet.input_win_amount) {
        return bet.input_win_amount;
      }
      return '0.00';
    },
    getWinAmountForIfBet(bet, odd) {
      return parseFloat(bet.input_risk_amount) * americanToDecimal(odd);
    },
  },
};
</script>
<style lang="scss">
.modal__header {
  .title {
    color: var(--color3);
    text-transform: uppercase;
    letter-spacing: 0;
    margin: 0;
    font-size: 18px;
    font-weight: bold;
    line-height: 20px;
  }

  @media (max-width: 768px) {
    .modal__icon {
      width: 60px;
      height: 60px;
    }
  }
}
.bet-slip-confirmation-row {
  border-bottom: 1px solid #f4f4f4;
  margin-bottom: 10px;
  padding-bottom: 3px;

  &:last-of-type {
    margin-bottom: 0;
    border-bottom: 0;
    padding-bottom: 0;
  }

  .bet-slip-odd {
    margin: 0 !important;
  }
  .bet-slip-odd.not-accepted {
    background: transparent !important;
    color: #000;
    font-weight: bold;
    padding: 0 !important;
    margin: 0 !important;

    .odds {
      margin: 0 !important;
      padding: 0 !important;
    }
  }
}
.placed-risk-win-area {
  color: #343a40;
}

.custom-confirmation-row {
  border-bottom: unset !important;
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
}

.custom-selection-lines {
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 5px;
  @media (max-width: 768px) {
    font-size: 13px !important;
  }
}
</style>
